import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import { TemplateSet, TemplateSetAggregate } from "../../services/api/TemplateSets";

const TemplateSetRowAction: React.FC<{ templateSetAggregate: TemplateSetAggregate }> = ({
  templateSetAggregate,
}) => {
  const navigate = useNavigate();
  const handleRowActionButtonEdit = useCallback(() => {
    navigate(`/template-sets/${templateSetAggregate.id}`);
  }, [navigate, templateSetAggregate.id]);

  const handleRowActionButtonRestore = () => {
    const templateSet = new TemplateSet({
      template_names: templateSetAggregate.templates?.map((v) => v.name) ?? [],
      ...templateSetAggregate,
    });
    templateSet.disabled = false;
    templateSet.update().then(() => navigate(`/template-sets/${templateSetAggregate.id}`));
  };

  return (
    <Button
      size="small"
      variant="contained"
      color={templateSetAggregate.disabled ? "error" : "primary"}
      onClick={templateSetAggregate.disabled ? handleRowActionButtonRestore : handleRowActionButtonEdit}
    >
      {templateSetAggregate.disabled ? "Restore" : "Edit"}
    </Button>
  );
};

export default TemplateSetRowAction;
